import Swiper from 'swiper/bundle';

(function ($) {
    // 1. Find all tab containers that hold the sliders
    const tabPanes = document.querySelectorAll('.section-our-media .tab-pane');

    tabPanes.forEach(tab => {
        // 2. Inside each tab, find its unique Swiper elements
        const swiperContainer = tab.querySelector('.slider-media.swiper');
        const prevButton = tab.querySelector('.swiper-button-prev');
        const nextButton = tab.querySelector('.swiper-button-next');
        const scrollbarEl = tab.querySelector('.swiper-scrollbar');

        if (swiperContainer) {
            // 3. Initialize Swiper for the FOUND container
            let swiper = new Swiper(swiperContainer, {
                slidesPerView: 'auto',
                spaceBetween: 24,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                scrollbar: {
                    el: scrollbarEl,
                    draggable: true,
                },
                breakpoints: {
                    300: {
                        spaceBetween: 16,
                    },
                    767: {
                        spaceBetween: 20,
                    },
                    1439: {
                        spaceBetween: 24,
                    },
                }
            });

            // 5. Handle the tab show event (for initializing/updating hidden sliders)
            $(tab).on('shown.bs.tab', function () {
                swiper.update();
            });
        }
    });

    // center tab
    function centerActiveCategory() {
        if (window.innerWidth < 767) {
            const $activeCategory = $('.section-our-media .nav-tabs .item.position-center');

            if ($activeCategory.length) {
                const $scrollContainer = $('.section-our-media .wrap-scroll');
                const activeOffsetLeft = $activeCategory[0].offsetLeft;
                const activeWidth = $activeCategory.outerWidth();
                const containerWidth = $scrollContainer.width();
                const scrollPosition = activeOffsetLeft - (containerWidth / 2) + (activeWidth / 2);
                $scrollContainer.animate({scrollLeft: scrollPosition}, 300, 'swing');
            }
        }
    }

    centerActiveCategory();

    $('.section-our-media .nav-tabs .item a').on('click', function (e) {
        e.preventDefault();
        const $parentItem = $(this).parent();
        $parentItem.addClass('position-center').siblings().removeClass('position-center');
        centerActiveCategory();
    });

})(jQuery);